import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../apiInstances/axiosInstance";

const pickRandomAgent = (list) => {
  if (!Array.isArray(list) || list.length === 0) return null;
  const index = Math.floor(Math.random() * list.length);
  return list[index];
};

export function useLatestAgents() {
  const [agents, setAgents] = useState([]);
  const [featuredAgent, setFeaturedAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const loadAgents = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);
      const res = await axiosInstance.get("/latestagent");
      const list = Array.isArray(res?.data?.data) ? res.data.data : [];
      setAgents(list);
      setFeaturedAgent(pickRandomAgent(list));
    } catch (err) {
      console.log(err);
      setError(true);
      setAgents([]);
      setFeaturedAgent(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAgents();
  }, [loadAgents]);

  return {
    agents,
    featuredAgent,
    loading,
    error,
    refetch: loadAgents,
  };
};
